export const GetSystemHealth = async () => {
    const response = await fetch(`${window.API_URL}health/live/`, { method: "GET" });
    if (response.status === 200) {
        return true;
    }
    throw new Error(`Health check failed with status: ${response.status}`);
};



export const checkNetworkConnectivity = async () => {
    try {
        await fetch("https://medapp.jozoortech.com/images/Medicine.ico", {
            method: 'GET',
            mode: 'no-cors',
            cache: "no-cache"
        });

        return true;
    } catch (error) {
        return false;
    }
};